import { Children, ReactElement } from 'react';

import { DrawerTypes } from '@/common/Drawer/types';
import { Offcanvas } from 'react-bootstrap';
import { getClasses } from '@/utils';

const DrawerBody = ({ children, ...bodyProps }: DrawerTypes.BodyProps): ReactElement => {
  // If no children, then show nothing
  if (Children.count(children) === 0) return null;
  return (
    <Offcanvas.Body {...bodyProps} className={getClasses('Drawer-Body', bodyProps.className)}>
      {children}
    </Offcanvas.Body>
  );
};

export default DrawerBody;
